// extracted by mini-css-extract-plugin
module.exports = {"overlay":"HistoryView_overlay__py1xO","noDisplay":"HistoryView_noDisplay__OijGo","noMargin":"HistoryView_noMargin__iGWCt","table":"HistoryView_table__uKZqh"};